export default "__VITE_ASSET__C8gPIh0K__"